import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faTimesCircle,
  faEdit,
  faCopy,
  faLink,
  faCheckCircle,
  faArrowDown,
  faArrowUp,
  faCheck,
  faInfo,
  faInfoCircle,
  faBan,
  faUndo,
  faUtensils,
  faFileExport,
  faHome,
  faEnvelope,
  faComment,
  faNewspaper,
  faRedo,
  faImages,
  faExclamationTriangle,
  faShoePrints,
  faArrowRight,
  faArrowLeft,
  faUtensilSpoon,
  faUserTimes,
  faUserCheck,
  faReceipt,
  faCrown,
  faVolumeUp,
  faDollarSign,
  faHandHoldingUsd,
  faPaperclip,
  faTimes,
  faFileExcel,
  faMapMarkedAlt,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faEllipsisV,
  faPlusSquare,
  faAlignJustify,
  faArrowsAlt,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faSpinner,
  faTimesCircle,
  faEdit,
  faCopy,
  faLink,
  faCheckCircle,
  faArrowDown,
  faArrowUp,
  faCheck,
  faInfo,
  faInfoCircle,
  faBan,
  faUndo,
  faUtensils,
  faFileExport,
  faHome,
  faEnvelope,
  faComment,
  faNewspaper,
  faRedo,
  faImages,
  faExclamationTriangle,
  faShoePrints,
  faArrowRight,
  faArrowLeft,
  faUtensilSpoon,
  faUserTimes,
  faUserCheck,
  faReceipt,
  faCrown,
  faVolumeUp,
  faDollarSign,
  faHandHoldingUsd,
  faPaperclip,
  faTimes,
  faFileExcel,
  faMapMarkedAlt,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faEllipsisV,
  faPlusSquare,
  faAlignJustify,
  faArrowsAlt,
  faEllipsisH,
);



// WEBPACK FOOTER //
// ./src/plugins/font-awesome.js